import { TextSection } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import { useTranslation } from '@frontend/i18n';
import { useSettingsForm } from '../../content-composer/hooks/use-settings-form';
import { FrameSetting } from '../../content-composer/settings-atoms/frame-setting';
import { PaddingSetting } from '../../content-composer/settings-atoms/padding-setting';
import { SettingsPanel } from '../../content-composer/settings-panel/settings-panel';

export const TextSettings = () => {
  const { t } = useTranslation('content-composer');

  const { getFieldProps } = useSettingsForm<TextSection>({
    frame: {
      alignment: { type: 'radio' },
      backgroundColor: { type: 'text' },
      paddingTop: { type: 'text' },
      paddingBottom: { type: 'text' },
      paddingLeft: { type: 'text' },
      paddingRight: { type: 'text' },
    },
  });

  return (
    <SettingsPanel>
      <SettingsPanel.Header>{t('Text')}</SettingsPanel.Header>
      <SettingsPanel.Body>
        <FrameSetting {...getFieldProps('frame', 'backgroundColor')} />
        <PaddingSetting
          paddingTopFieldProps={getFieldProps('frame', 'paddingTop')}
          paddingBottomFieldProps={getFieldProps('frame', 'paddingBottom')}
          paddingRightFieldProps={getFieldProps('frame', 'paddingRight')}
          paddingLeftFieldProps={getFieldProps('frame', 'paddingLeft')}
        />
      </SettingsPanel.Body>
    </SettingsPanel>
  );
};
